// Main entry point
import './styles/main.css';
import './styles/toolbar.css';
import './styles/tabs.css';
import './styles/editor.css';
import './styles/dialogs.css';
import { App } from './app';

// Error handler for uncaught errors
window.addEventListener('error', (event) => {
  console.error('Uncaught error:', event.error);
  // In production, you could send this to an error tracking service
});

// Error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  event.preventDefault();
});

// Initialize app when DOM is ready
async function initApp() {
  try {
    const app = new App();
    await app.init();
    console.log('✅ Text Editor PWA initialized successfully');
  } catch (error) {
    console.error('❌ Failed to initialize app:', error);
    // Show user-friendly error message
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: #f44336; color: white; padding: 20px; border-radius: 8px; text-align: center; max-width: 400px; z-index: 10000;';
    errorDiv.innerHTML = `
      <h2>Failed to Initialize Editor</h2>
      <p>The text editor failed to load. This could be due to:</p>
      <ul style="text-align: left;">
        <li>Browser compatibility issues</li>
        <li>Network connection problems</li>
        <li>Storage quota exceeded</li>
      </ul>
      <p>Please try refreshing the page or clearing your browser cache.</p>
      <button onclick="location.reload()" style="background: white; color: #f44336; border: none; padding: 10px 20px; border-radius: 4px; cursor: pointer; margin-top: 10px;">
        Refresh Page
      </button>
    `;
    document.body.appendChild(errorDiv);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}

// Register service worker (handled by vite-plugin-pwa)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('✅ Service Worker registered:', registration);
      })
      .catch((error) => {
        console.warn('⚠️ Service worker registration failed:', error);
        // App can still work without SW, just without offline support
      });
  });
}
